// extracted by mini-css-extract-plugin
module.exports = {"overlay":"PlayerDebugOverlay_overlay__To1Be"};